import { render, staticRenderFns } from "./planFormat.vue?vue&type=template&id=1fd20f11&scoped=true&"
import script from "./planFormat.vue?vue&type=script&lang=js&"
export * from "./planFormat.vue?vue&type=script&lang=js&"
import style0 from "./planFormat.vue?vue&type=style&index=0&id=1fd20f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd20f11",
  null
  
)

/* custom blocks */
import block0 from "./planFormat.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports